import { Box, Grid, Tooltip, Typography } from "@mui/material";
import { TabHeader } from "./TabHeader";
import { achievements, isAchievementUnlocked } from "../../types/achievements";
import { useContext } from "react";
import { GameContext } from "../../provider/GameProvider";
import { ShootingStar, Star } from "@phosphor-icons/react";

export default function AchievementTab(props: {}) {
  const { achievementMultiplier, game } = useContext(GameContext);
  return (
    <Grid container spacing={2}>
      <TabHeader />
      <div>
        <Typography
          variant="h5"
          style={{ color: "lightblue", textAlign: "center", paddingBottom: 8 }}
        >
          Achievements
        </Typography>
        <Typography
          style={{ color: "white", textAlign: "center", paddingBottom: 32 }}
        >
          x{achievementMultiplier.toFixed(3)} Multiplier to all Producers
        </Typography>
      </div>
      <Grid container spacing={2} justifyContent="center">
        {achievements.map((achievement, index) => (
          <Grid item key={index}>
            <Tooltip
              title={
                <div>
                  <div>{achievement.description}</div>
                  {achievement.additionalEffect && (
                    <div>Additional Effect: {achievement.additionalEffect}</div>
                  )}
                </div>
              }
              placement="top"
            >
              <Box
                width={100}
                height={100}
                border={1}
                borderRadius={8}
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgcolor={
                  isAchievementUnlocked(
                    achievement.id,
                    game.unlockedAchievementIds
                  )
                    ? "#2196f3"
                    : "lightgray"
                }
                textAlign={"center"}
                position={"relative"}
              >
                <Typography variant="body2" style={{ color: "black" }}>
                  {achievement.name}
                </Typography>
                {achievement.additionalEffect && (
                  <Star
                    size={24}
                    style={{
                      position: "absolute",
                      top: 20,
                      right: 20,
                      transform: "translate(50%, -50%)",
                      color: isAchievementUnlocked(
                        achievement.id,
                        game.unlockedAchievementIds
                      )
                        ? "yellow"
                        : "black",
                    }}
                    weight={
                      isAchievementUnlocked(
                        achievement.id,
                        game.unlockedAchievementIds
                      )
                        ? "fill"
                        : undefined
                    }
                  />
                )}
              </Box>
            </Tooltip>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}
